
import { locale } from 'moment';
import { setLocale } from 'yup';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import ruRU from 'antd/lib/locale-provider/ru_RU';
import enUS from 'antd/lib/locale-provider/en_US';

import 'moment/locale/ru';
import 'moment/locale/en-gb';

import validationLocale from '../constants/validationLocale';
import resources from '../translations';

const initialLang = 'ru';

const momentLocale = {
};

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: initialLang,
        interpolation: {
            escapeValue: false
        },
        react: {
            useSuspense: false
        },
        whitelist: ['ru', 'en']
    });

export const changeLocale = (language = initialLang) => {
    i18n.changeLanguage(language);
    locale(momentLocale[language] || language);
    setLocale(validationLocale[language]);
}

changeLocale();

export const configLocales = {
    'ru': ruRU,
    'en': enUS,
};

export default i18n;
